import { Box, ColorOptions, convertHexToRGBA, Image, Loader, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { SvgImage } from '../../comps/SvgImage'
import { Routes } from '../../nav/routes'
import { Colors, generateRandomString, showLast4Chars, testProps } from '../../util/util'
import { styles } from './styles'

interface actionButtonProps {
  text: string
  isRemove: boolean
  onPress: () => void
  removeBankAccState?: 'pending' | 'fulfilled' | 'rejected'
}

interface bankInfoProps {
  item: any
  keyMap?: any
  keyName: string
}

const BankInfoDesc: FC<bankInfoProps> = ({ item, keyName, keyMap = keyName }: bankInfoProps) => {
  const show = item[keyName] !== '' && typeof item[keyName] !== ('undefined' || null)
  if (!show) {
    return null
  }
  const keyLabelName = keyMap ? keyMap : item[keyName]?.toUpperCase()
  return (
    <Box pv={5} flexDirection="row" justifyContent={'space-between'} alignItems="center">
      <Text {...styles.bankInfoText}>{keyLabelName}</Text>
      <Text {...styles.bankInfoText} color={'#141414' as ColorOptions}>
        {item[keyName]}
      </Text>
    </Box>
  )
}

const AccountButton: FC<actionButtonProps> = ({ text, isRemove, onPress, removeBankAccState }: actionButtonProps) => {
  return (
    <Box onPress={onPress} {...testProps('generic-button')} {...styles.actionButton(isRemove)}>
      {removeBankAccState === 'pending' && isRemove ? (
        <Loader type="small" color="ERROR" />
      ) : (
        <Text {...styles.actionText(isRemove)}>{text}</Text>
      )}
    </Box>
  )
}

export const _renderItem = (
  item: any,
  navigation: any,
  setModalVisible: any,
  removeBankAccState: any,
  setPressedItem: (item: any) => void,
) => {
  const onChaneBank = () => {
    navigation?.navigate(Routes.ADD_ACCNT)
  }

  const makeModalVisible = () => {
    setModalVisible(true)
  }

  return (
    <ModBox
      direction="row"
      justify="space-between"
      p={20}
      borderBottomWidth={1}
      borderColor="LIGHTEST_GREY"
      key={generateRandomString(20)}>
      <Box height={40} width={40} alignItems={'center'}>
        <Image height={34} width={34} resizeMode="center" source={'https://pngimg.com/uploads/bank/bank_PNG3.png'} />
      </Box>
      <Box flexGrow={1} paddingHorizontal={16}>
        <Text {...styles.accountText}>{showLast4Chars(item?.number)}</Text>
        <Spacer size={8} />
        <BankInfoDesc item={item} keyName="bankName" />
        <BankInfoDesc item={item} keyName="addressLine" />
        <BankInfoDesc item={item} keyName="ifsc" />
        <ModBox show={false} flexDirection="row" mt={20}>
          <AccountButton text="Change Bank A/c" isRemove={false} onPress={onChaneBank} />
          <Spacer direction="horizontal" size={20} />
          <AccountButton
            text="Remove A/c"
            isRemove={true}
            onPress={() => [makeModalVisible(), item, setPressedItem(item)]}
            removeBankAccState={removeBankAccState}
          />
        </ModBox>
      </Box>
    </ModBox>
  )
}

export const renderItemBanKDetail = (item: any) => {
  const accountNumber = item?.number
  let acc: string = accountNumber?.slice(0, accountNumber?.length - 4)
  acc = acc?.replaceAll(/./gi, 'x')
  return (
    <ModBox
      p={20}
      borderRadius={16}
      bg={convertHexToRGBA(Colors.PRIMARY, 10) as ColorOptions}
      borderWidth={1}
      borderColor={'#e7ebfa' as ColorOptions}
      key={generateRandomString(20)}>
      <Box height={48} width={48} borderRadius={48} justifyContent="center" alignItems={'center'} bg={'PRIMARY'}>
        <SvgImage imageName="BankIcon" />
      </Box>
      <Spacer direction="vertical" size={20} />
      <Box>
        <Box justifyContent={'flex-end'}>
          <Text {...styles.accountText}>
            <Text fontFamily={'JioType-Bold'} lineHeight={20} color={'#141414' as ColorOptions} fontSize={14}>
              {acc}
            </Text>
            {accountNumber?.slice(accountNumber?.length - 4)}
          </Text>
        </Box>
        <Text fontFamily={'JioType-Medium'} lineHeight={20} color={'#141414' as ColorOptions} fontSize={14}>
          {item?.bankName}
        </Text>
        <Spacer direction="vertical" size={10} />
        <BankInfoDesc item={item} keyName="accountType" keyMap={'Account Type'} />
        <BankInfoDesc item={item} keyName="ifsc" keyMap={'IFSC Code'} />
        <BankInfoDesc item={item} keyName="branch" keyMap={'Branch'} />
        <BankInfoDesc item={item} keyName="addressLine" keyMap={'ADDRESS'} />
      </Box>
    </ModBox>
  )
}
